<template>
  <div>
    <div class="common-box margin-t10">
      <el-row class="row-one">
        <span class="row-one-title">组合资产信息</span>
        <Reback v-show="this.$route.name !== 'myAssets'" class="row-one-fr" @click.native="returnClick"></Reback>
      </el-row>
      <el-radio-group class="radio-single-btn margin-t20" v-model="radio" size="medium">
        <el-radio-button :label="1">持仓信息{{ ' ( '+holdFundTableData.length+' ) '}}</el-radio-button>
        <el-radio-button :label="2">确认中{{' ( '+confirmTableData.length+' ) '}}</el-radio-button>
      </el-radio-group>
      <!-- 持仓信息 -->
      <el-table v-if="radio==1" key="holdFundTable" v-loading="loadingOne" element-loading-text="加载中..." class="table-single margin-t20" :data="holdFundTableData" ref="holdFundTableRef" style="width: 100%">
        <el-table-column label="组合名称" prop="funddesc" width="170">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="light" popper-class="table-single-tip" :content="scope.row.funddesc" placement="right">
              <a :href="getTypeCode (scope.row.funddesc) == 0?'javascript:;':'https://www.myfund.com/AccurateFinancingProduct.html?type='+getTypeCode (scope.row.funddesc)+''" class="table-single-a" :target="getTypeCode (scope.row.funddesc) == 0?'_self':'_blank'">{{scope.row.funddesc}}</a>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="更新日期" prop="navdate">
        </el-table-column>
        <el-table-column label="当前市值" prop="mktvalue">
        </el-table-column>
        <el-table-column label="昨日收益" prop="yestdayprofit">
          <template slot-scope="scope">
            <span v-if="scope.row.yestdayprofit > 0" class="rColor">{{'+'+scope.row.yestdayprofit}}</span>
            <span v-else-if="scope.row.yestdayprofit < 0" class="gColor">{{scope.row.yestdayprofit}}</span>
            <span v-else>{{scope.row.yestdayprofit}}</span>
          </template>
        </el-table-column>
        <el-table-column label="持有收益" prop="phaseprofit">
          <template slot-scope="scope">
            <span v-if="scope.row.phaseprofit > 0" class="rColor">{{'+'+scope.row.phaseprofit}}</span>
            <span v-else-if="scope.row.phaseprofit < 0" class="gColor">{{scope.row.phaseprofit}}</span>
            <span v-else>{{scope.row.phaseprofit}}</span>
          </template>
        </el-table-column>
        <el-table-column label="仓位差异" prop="different">
          <template slot-scope="scope">
            <div v-if="scope.row.combinationcode != 'ZH0014' && scope.row.combinationcode != 'ZH0015' && scope.row.combinationcode != 'ZH0016'&&scope.row.combinationcode != 'ZH0017'&&scope.row.combinationcode != 'ZH0018'">
              <span>{{scope.row.different}}</span>
              <span v-show="scope.row.different == null">--</span>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="tap" width="225">
          <template slot-scope="scope">
            <!-- scope.row.combinationcode == 'ZH0004' &&  -->
            <span v-if="scope.row.tap == '0' && scope.row.againBuy == false">--</span>
            <span v-show="scope.row.againBuy" class="table-single-btn-normal" @click="buyAgainClick(scope.row)">再次买入</span>
            <!-- <span v-if="scope.row.combinationcode != 'ZH0004'" class="table-single-btn-normal" @click="adjustClick(scope.row)">调仓</span> -->
            <span v-show="scope.row.tap == '1'" class="table-single-btn-normal" @click="sellClick(scope.row)">卖出</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="组合收益明细" prop="cczh">
          <template slot-scope="scope">
            <span class="table-single-a" @click="checkDetailClick(scope.row)">查看收益明细</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="组合配置" prop="cczh">
          <template slot-scope="scope">
            <span class="table-single-a" @click="checkDetailClick(scope.row)">配置详情</span>
          </template>
        </el-table-column> -->
        <el-table-column width="100" label="资产详情">
          <template slot-scope="scope">
            <span class="open" type="text" @click="holdToogleExpand(scope.row)">{{scope.row.toogle? '展开':'收起'}}
              <i :class="scope.row.toogle? 'el-icon-arrow-down':'el-icon-arrow-up'"></i>
            </span>
          </template>
        </el-table-column>
        <!-- 展开 -->
        <el-table-column type="expand" width="1">
          <template slot-scope="props">
            <el-table class="table-single table-sub" stripe :data="props.row.children" style="width: 100%">
              <el-table-column prop="fundcode" label="基金代码">
              </el-table-column>
              <el-table-column prop="fundcodename" label="基金名称" width="200">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="light" popper-class="table-single-tip" :content="scope.row.fundcodename" placement="right">
                    <a :href="'https://www.myfund.com/mutualfund/'+ scope.row.fundcode +'.html'" class="table-single-a" target="_blank">{{scope.row.fundcodename}}</a>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="fundtype" label="基金类型">
                <template slot-scope="scope">
                  {{scope.row.fundType}}
                </template>
              </el-table-column>
              <el-table-column prop="nav" label="最新净值">
              </el-table-column>
              <el-table-column prop="navdate" label="更新日期">
              </el-table-column>
              <el-table-column prop="fundvol" label="基金份额">
              </el-table-column>
              <el-table-column prop="availbal" label="可用份额">
              </el-table-column>
              <el-table-column prop="mktvalue" label="当前市值">
              </el-table-column>
              <el-table-column prop="yestdayprofit" label="昨日收益">
                <template slot-scope="scope">
                  <span v-if="scope.row.yestdayprofit > 0" class="rColor">{{'+'+scope.row.yestdayprofit}}</span>
                  <span v-else-if="scope.row.yestdayprofit < 0" class="gColor">{{scope.row.yestdayprofit}}</span>
                  <span v-else>{{scope.row.yestdayprofit}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="phaseprofit" label="持有收益">
                <template slot-scope="scope">
                  <span v-if="scope.row.phaseprofit > 0" class="rColor">{{'+'+scope.row.phaseprofit}}</span>
                  <span v-else-if="scope.row.phaseprofit < 0" class="gColor">{{scope.row.phaseprofit}}</span>
                  <span v-else>{{scope.row.phaseprofit}}</span>
                  <!-- <span :class="scope.row.phaseprofit >= 0? 'rColor':'gColor'">{{scope.row.phaseprofit >= 0? '+'+scope.row.phaseprofit:scope.row.phaseprofit}}</span> -->
                </template>
              </el-table-column>
              <el-table-column prop="proportion" label="基金仓位">
                <template slot-scope="scope"><span>{{scope.row.proportion?scope.row.proportion:'--'}}</span></template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
      </el-table>
      <!-- 确认中 -->
      <el-table v-else-if="radio==2" key="confirmTable" v-loading="loadingTwo" element-loading-text="加载中..." class="table-single  margin-t20" :data="confirmTableData" ref="confirmTableRef" style="width: 100%">
        <el-table-column label="申请时间" prop="time" width="180">
        </el-table-column>
        <el-table-column label="组合名称" prop="combinationcode" width="180">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="light" popper-class="table-single-tip" :content="scope.row.combinationcode" placement="right">
              <a :href="getTypeCode (scope.row.combinationcode) == 0?'javascript:;':'https://www.myfund.com/AccurateFinancingProduct.html?type='+getTypeCode (scope.row.combinationcode)+''" class="table-single-a" :target="getTypeCode (scope.row.combinationcode) == 0?'_self':'_blank'">{{scope.row.combinationcode}}</a>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="交易类型" prop="type">
        </el-table-column>
        <el-table-column label="交易金额" prop="investamount">
        </el-table-column>
        <el-table-column label="实际金额" prop="moneyasset">
        </el-table-column>
        <el-table-column label="关联账户" prop="account" width="183">
        </el-table-column>
        <el-table-column label="交易状态">
          <template>
            <span style="color:#246EAD">确认中</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="165">
          <template slot-scope="scope">
            <span v-show="!canaleFlag">--</span>
            <span v-show="canaleFlag" class="table-single-btn-normal" @click="cancelDialog(scope.row)">撤单</span>
          </template>
        </el-table-column>
        <!-- 展开 -->
        <el-table-column width="100">
          <template slot-scope="scope">
            <span class="open" type="text" @click="toogleExpand(scope.row)">{{scope.row.toogle1? '展开':'收起'}}
              <i :class="scope.row.toogle1? 'el-icon-arrow-down':'el-icon-arrow-up'"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column type="expand" width="1">
          <template slot-scope="props">
            <el-table class="table-single table-sub" stripe :data="props.row.children" style="width: 100%">
              <el-table-column prop="fundcode" label="基金代码">
              </el-table-column>
              <el-table-column prop="fundname" label="基金名称" width="200">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="light" popper-class="table-single-tip" :content="scope.row.fundname" placement="right">
                    <a :href="'https://www.myfund.com/mutualfund/'+ scope.row.fundcode +'.html'" class="table-single-a" target="_blank">{{scope.row.fundname}}</a>
                    <!-- <a href="javascript:;" class="table-single-a">{{scope.row.fundname}}</a> -->
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="fundtype" label="基金类型">
              </el-table-column>
              <el-table-column prop="transstatus" label="交易状态">
              </el-table-column>
              <el-table-column prop="investamount" label="交易金额">
              </el-table-column>
              <el-table-column prop="share" label="基金份额">
              </el-table-column>
              <el-table-column prop="nav" label="确认净值">
              </el-table-column>
              <el-table-column prop="charge" label="交易费用">
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 功能开发中 -->
    <el-dialog class="dialog-single-one" center :visible.sync="dialogVisable1" :show-close="false">
      <img src="../../../assets/images/development.png" alt="" style="width:120px;height:110px;">
      <span slot="footer" class="dialog-footer">
        <el-button type="normal1" @click="dialogVisable1 = false">确定</el-button>
      </span>
    </el-dialog>
    <!--撤单弹框 -->
    <el-dialog class="dialog-single-three" :visible.sync="cancelDialogVisable" :close-on-click-modal="false" :before-close="cancelReturn">
      <div class="dialog-single-three-p">请输入支付密码</div>
      <el-form :model="cancelForm" ref="cancelFormRef" class="margin-t20" style="position: relative;">
        <el-form-item label="活动名称" prop="name" style="display:none;">
          <el-input v-model="cancelForm.name"></el-input>
        </el-form-item>
        <el-form-item prop="pass">
          <el-input v-model="cancelForm.pass" type="password" autocomplete="new-password" @blur="passBlur" show-password></el-input>
          <span class="dialog-single-three-error" v-show="errorShow">{{errorMessage}}</span>
        </el-form-item>
      </el-form>
      <div class="margin-t35">
        <el-button type="normal1" @click="canaleOrderClick">确定</el-button>
        <el-button type="cancel" style="width:154px" @click="cancelReturn">返回</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "combinationAssetsMessage",
  data () {
    return {
      dialogVisable1: false,
      radio: '1',
      holdFundTableData: [],
      toogle: true,
      toogle1: true,
      toogleText: '展开',
      openicon: 'el-icon-arrow-down',
      confirmTableData: [],
      Cha: 0,
      tap: '0', //是否可赎回标识 0 不可以  1 可以
      comfundlist: '',
      // 子表字段
      fundType: '',
      againBuy: '',
      // 确认中
      end: '',
      cflag: false,
      objArr: new Array(),
      objArr2: new Array(),
      canaleFlag: false,
      loadingOne: true,
      loadingTwo: true,
      // 撤单
      cancelDialogVisable: false,
      errorMessage: '',
      errorShow: false,
      cancelForm: {
        name: '',
        pass: ''
      },
      combuyappsheetno: '',
    }
  },
  mounted () {
    this.getFundCombinationNew()
    this.getConfirm()

  },
  methods: {
    returnClick () {
      let path = this.$route.params.value
      path ? this.$router.push({ name: path }) : this.$router.push({ name: 'myAssets' })
    },
    buyAgainClick (rows) {
      // this.dialogVisable1 = true
      this.$router.push({
        name: 'fundCombinationSingleBuy',
        params: {
          message: rows
        }
      })
    },
    // 调仓
    adjustClick (rows) {
      if (rows.funddesc.indexOf('精准理财') != -1) {
        this.$router.push({ name: 'combinationSmartAdjust', params: { row: rows } })
      } else {
        this.$router.push({ name: 'combinationAdjustDetail', params: { row: rows } })
      }
    },
    sellClick (rows) {
      this.$router.push({
        name: 'combinationSell',
        params: {
          message: rows
        }
      })
    },
    // 展开功能（最后封装）
    holdToogleExpand (row) {
      row.toogle = !row.toogle
      let $table = this.$refs.holdFundTableRef;
      this.holdFundTableData.map((item) => {
        if (row.id != item.id) {
          $table.toggleRowExpansion(item, false)
        }
      })
      $table.toggleRowExpansion(row)
    },
    toogleExpand (row) {
      row.toogle1 = !row.toogle1
      let $table = this.$refs.confirmTableRef;
      this.confirmTableData.map((item) => {
        if (row.id != item.id) {
          $table.toggleRowExpansion(item, false)
        }
      })
      $table.toggleRowExpansion(row)
    },
    // 配置详情
    checkDetailClick (rows) {
      this.$router.push({
        name: 'combinationIncomedetails',//fundCombinationDetail combinationIncomedetails
        params: {
          message: rows
        }
      })
    },
    // 组合持仓信息
    getFundCombinationNew () {
      // 接口1
      this.$http.post(this.$apiPath.fundCombinationNew, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        custno: this.$commonJs.getCookie('u_custno1')
      }).then(async res1 => {
        if (res1.status !== 200) return
        if (res1.data.code == '200') {
          // console.log(res1);
          const total = res1.data.data
          if (total.fundCombinationList && total.fundCombinationList.length > 0) {
            for (var i = 0; i < total.fundCombinationList.length; i++) {
              var item = total.fundCombinationList[i]
              item.toogle = true
              // 基金组合
              item.funddesc = item.combinationcode ? this.$commonJs.getCombinationNameByCode(item.combinationcode) : '--'
              // 更新日期
              item.navdate = this.$commonJs.getDateStrTh(item.navdate)
              // 当前市值
              item.mktvalue = item.mktvalue ? parseFloat(item.mktvalue).toFixed(2) : '--'
              // 昨日收益
              item.yestdayprofit = item.yestdayprofit ? parseFloat(item.yestdayprofit).toFixed(2) : '--'
              if (item.yestdayprofit == 0.00) { item.yestdayprofit = item.yestdayprofit ? parseFloat(item.yestdayprofit.substr(1)).toFixed(2) : '--' }
              // 持有收益
              item.phaseprofit = item.phaseprofit ? parseFloat(item.phaseprofit).toFixed(2) : '--'
              // 组合持有基金的列表
              item.children = this.getChildren(item, total.fundCombinationList1)
              // 子表循环
              item.children.forEach(item1 => {
                var fundtypeObj = {
                  '0': '股票型基金',
                  '1': '债券型基金',
                  '2': '货币型基金',
                  '3': '混合型基金',
                  '4': '专户基金',
                  '5': '指数型基金',
                  '6': 'QDII基金'
                };
                item1.fundType = item1.fundtype ? fundtypeObj[item1.fundtype] : '--'
                // 最新净值
                item1.nav = item1.nav ? parseFloat(item1.nav).toFixed(4) : '--'
                // 更新日期
                item1.navdate = this.$commonJs.getDateStrTh(item1.navdate)
                // 基金份额
                item1.fundvol = item1.fundvol ? parseFloat(item1.fundvol).toFixed(2) : '--'
                item1.availbal = item1.availbal ? parseFloat(item1.availbal).toFixed(2) : '--'
                item1.mktvalue = item1.mktvalue ? parseFloat(item1.mktvalue).toFixed(2) : '--'
                item1.yestdayprofit = item1.yestdayprofit ? parseFloat(item1.yestdayprofit).toFixed(2) : '--'
                item1.phaseprofit = item1.phaseprofit ? parseFloat(item1.phaseprofit).toFixed(2) : '--'
                if (item1.different && item1.different.indexOf("-") != -1) {
                  item1.different = item1.different.replace('-', '')
                }
                // item1.different = item1.different.indexOf("-") != -1 ? item1.different.replace('-', '') : item1.different
              })
              var thatItem = item
              // 仓位差异      接口2
              // var ChaYi = 0;
              // await this.$http.post(this.$apiPath.groupDetailList, {
              //   combinationcode: thatItem.combinationcode
              // }).then(res2 => {
              //   if (res2.status !== 200) return
              //   if (res2.data.code !== '200') return
              //   const subTotal = res2.data.data
              //   //标准组合基金中有但持有基金没有的基金差异数组
              //   var fundCommon = []
              //   subTotal.groupDetail.forEach((val1) => {
              //     var commonFlag = false;
              //     thatItem.children.forEach((val2) => {
              //       if (val1.fundcode == val2.fundcode) {
              //         commonFlag = true;
              //       }
              //     })
              //     if (!commonFlag) {
              //       fundCommon.push({ "fundcode": val1.fundcode, "chaY": parseFloat(val1.comrate) / 2 })
              //     }
              //   })
              //   //共同数组中加入持有基金及持仓差异数据，形成总的持仓差异列(标准组合基金及持有基金共涉及到的基金数组)
              //   thatItem.children.forEach((val2) => {
              //     var commonFlag2 = false;
              //     subTotal.groupDetail.forEach((val1) => {
              //       if (val1.fundcode == val2.fundcode) {
              //         commonFlag2 = true
              //         fundCommon.push({ "fundcode": val2.fundcode, "chaY": ((parseFloat(val2.mktvalue) / thatItem.mktvalue) - parseFloat(val1.comrate)) / 2 })
              //       }
              //     })
              //     if (!commonFlag2) {
              //       fundCommon.push({ "fundcode": val2.fundcode, "chaY": (parseFloat(val2.mktvalue) / thatItem.mktvalue) / 2 })
              //     }
              //   })
              //   fundCommon.forEach(function (val4) {
              //     ChaYi += Math.abs(val4.chaY)
              //   })
              //   thatItem.ChaYi = (ChaYi * 100).toFixed(2) + "%";
              // }).catch(err => { })
              // 是否可赎回  接口3
              for (var k = 0; k < thatItem.children.length; k++) {
                if (k == 0) {
                  this.comfundlist += thatItem.children[k].fundcode
                }
                this.comfundlist += "," + thatItem.children[k].fundcode
              }
              // 是否可赎回标识 0 不可以  1 可以
              await this.$http.post(this.$apiPath.getFenEshuHui, {
                custno: this.$commonJs.getCookie('u_custno1'),
                combinationcode: thatItem.combinationcode,
                transactionaccountid: thatItem.transactionaccountid,
                comfundlist: this.comfundlist
              }).then(res3 => {
                if (res3.status !== 200) return
                if (res3.data.code !== '200') return
                thatItem.tap = res3.data.data.shuHui.tap
              }).catch(err => { })
              // 再次买入
              if (thatItem.combinationcode == "ZHZ000" || thatItem.combinationcode == "ZHZ001" || thatItem.combinationcode == "ZHZ002" || thatItem.combinationcode == "ZHZ003" || thatItem.combinationcode == "ZH0034") {
                thatItem.againBuy = true
              } else {
                thatItem.againBuy = false
              }
            }
            this.loadingOne = false
          } else {
            this.loadingOne = false
          }
          this.holdFundTableData = total.fundCombinationList
        } else {
          this.loadingOne = false
        }
      }).catch(err => { })
    },
    // 组合确认中
    getConfirm () {
      this.$http.post(this.$apiPath.qeryBenchTrades, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        paycenterid: '',
        begindate: '20190810',
        enddate: this.getMonthTime(),
        businesscode: '',
        fundcode: '',
        transcode: ''
      }).then(res1 => {
        if (res1.status !== 200) return
        if (res1.data.code !== '200') return
        const total = res1.data.data
        if (total && total.length > 0) {
          total.forEach(item => {
            item.toogle1 = true
            // 申请时间
            item.operdate == null ? (item.time = '--') : (item.time = this.$commonJs.getDateStrTh(item.operdate) + " " + item.opertime)
            // 组合名称
            item.combinationcode = this.$commonJs.getCombinationNameByCode(item.combinationcode)
            // 交易类型
            if (item.status == '02') {
              item.type = "买入"
            } else if (item.status == '04') {
              item.type = "卖出"
            }
            // 交易金额
            item.moneyasset == '' ? (item.moneyasset = '--') : (item.moneyasset = item.moneyasset)
            // 关联账户
            item.account = ''
            if (item.businesskind == "0") {
              // value = "银行卡";
              if (item.channelid) {
                item.account += this.$parameterConfig.p_channelid[item.channelid]
              }
              if (item.depositacct) {
                item.account += "(**" + (item.depositacct).substring((item.depositacct).length - 4) + ")"
              }
              if (item.investamount && item.moneyasset) {
                if (parseFloat(item.investamount) - parseFloat(item.moneyasset) > 0) {
                  item.account += "+优惠券"
                }
              }
            } else {
              item.account += "恒宝宝";
            }
            // 撤单
            // 撤单判断
            const oldtime = this.$commonJs.getDateStrHg(item.transactiondate) + ' 15:00:00'
            const nowtime = this.$commonJs.timeFormat(new Date())
            if (this.$commonJs.tab(oldtime, nowtime) == "1") {//可撤单
              this.canaleFlag = true
            } else {
              this.canaleFlag = false
            }
            // 展开内容  接口2
            this.$http.post(this.$apiPath.qeryBenchTradesInfo, {
              sessionId: this.$commonJs.getCookie('sessionid'),
              combuyappsheetno: item.combuyappsheetno
            }).then(res2 => {
              // console.log(res2);
              if (res2.status !== 200) return
              if (res2.data.code !== '200') return
              const benchRecord = res2.data.data.benchRecord
              // console.log(benchRecord);
              benchRecord.forEach(item2 => {
                // 基金类型
                item2.fundtype = this.$parameterConfig.p_fundtype[item2.fundtype]
                // 交易状态
                if (item2.transstatus == '00') {
                  item2.transstatus = '已撤单'; //交易状态
                } else if (item2.transstatus == '01') {
                  item2.transstatus = '确认成功'; //交易状态
                } else if (item2.transstatus == '02') {
                  item2.transstatus = '确认失败'; //交易状态
                } else if (item2.transstatus == '03') {
                  item2.transstatus = '确认中'; //交易状态
                } else if (item2.transstatus == '04') {
                  item2.transstatus = '支付失败'; //交易状态
                } else if (item2.transstatus == '05') {
                  item2.transstatus = '异常'; //交易状态
                }
                // 交易金额
                item2.investamount = item2.investamount ? parseFloat(item2.investamount).toFixed(2) : "--";
                // 基金份额
                item2.share = '0.00'
                if (item2.businesscode == "24") { //卖出
                  item2.share = item2.applicationvol
                } else { //买入
                  item2.share = (item2.confirmedvol == "0.00" ? "--" : item2.confirmedvol);
                }
                // 确认净值
                item2.nav = item2.nav ? parseFloat(item2.nav).toFixed(4) : "--";
                //交易费用
                item2.charge = item2.charge ? parseFloat(item2.charge).toFixed(2) : "--";
              })
              item.children = benchRecord



            })

          })
          this.confirmTableData = total
          this.loadingTwo = false
        } else {
          this.confirmTableData = []
          this.loadingTwo = false
        }
      }).catch(err => { })
    },
    // 方法
    // 1父表每一项，2子表数组
    getChildren (mainItem, dataList) {
      var children = new Array()
      dataList.forEach(subItem => {
        if (subItem.combinationcode == mainItem.combinationcode) {
          children.push(subItem)
        }
      })
      return children
    },
    //申请时间格式
    getDateStrTh (date) {
      if ((!date) || (date.trim().length != 8)) {
        return "--";
      }
      return date.substr(0, 4) + "/" + date.substr(4, 2) + "/"
        + date.substr(6, 2) + "";
    },
    getTypeCode (name) {
      var code
      if (name == '安心养老(保守型)') {
        code = 1
      } else if (name == '步步稳盈(稳健型)') {
        code = 2
      } else if (name == '薪满益足(平衡型)') {
        code = 3
      } else if (name == '节节高升(成长型)') {
        code = 4
      } else if (name == '盆满钵盈(进取型)') {
        code = 5
      } else if (name == '擂主基金(激进型)') {
        code = 6
      } else {
        code = 0
      }
      return code
    },
    // 当前时间
    getCurrentDate () {
      var d = new Date();
      var d1 = d.getFullYear();
      var d2 = d.getMonth() + 1;
      d2 = d2 < 10 ? '0' + d2 : "" + d2;
      var d3 = d.getDate();
      d3 = d3 < 10 ? '0' + d3 : "" + d3;
      return d1 + d2 + d3;
    },
    // 一个月后时间
    getMonthTime () {
      var d = new Date();
      var year = d.getFullYear();
      var mon = d.getMonth() + 1;
      var day = d.getDate();
      if (mon + 1 > 12) {
        year = year + 1;
        mon = 1;
      } else {
        mon = mon + 1;
      }
      var end = "" + year + (mon < 10 ? ('0' + mon) : mon) + (day < 10 ? ('0' + day) : day);
      return end
    },
    // 撤单
    cancelDialog (rows) {
      this.combuyappsheetno = rows.combuyappsheetno
      this.cancelDialogVisable = true
    },
    cancelOrder () {
      this.$http.post(this.$apiPath.deleteTradesnew2, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        originalappsheetno: this.combuyappsheetno,
        deviceId: '',
        appnew: '1'
      }).then(res => {
        // console.log(res);
        if (res.status !== 200) return
        if (res.data.code == '200') {
          if (res.data.data.code == "0000") {
            this.$message.success('撤销成功')
            this.getConfirm()
            // 推送消息
            this.$store.dispatch({
              type: "pushNews",
              index: 23,
              fundname: "组合",
              money: "",
              dtDate: "",
              fundname2: ""
            })
          } else {
            this.$message.error(res.data.data.msg)
          }
        } else {
          this.$message.error(res.data.message)
        }
        this.cancelDialogVisable = false
        this.$refs.cancelFormRef.resetFields()
      })
    },
    canaleOrderClick () {
      if (this.cancelForm.pass.trim() == "") {
        this.errorShow = true
        this.errorMessage = "请输入密码"
      } else {
        this.errorShow = false
        this.errorMessage = ""
        var inputpwd = this.$des.enString(this.cancelForm.pass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3)
        var reallypass = this.$commonJs.getCookie('Password')
        if (inputpwd != reallypass) {
          this.errorShow = true
          this.errorMessage = "密码输入错误"
        } else {
          this.errorShow = false
          this.errorMessage = ""
          this.cancelOrder()
        }
      }
    },
    cancelReturn () {
      this.cancelDialogVisable = false
    },
    passBlur () {
      if (this.cancelForm.pass.trim() == "") {
        this.errorShow = true
        this.errorMessage = "请输入密码"
      } else {
        this.errorShow = false
        this.errorMessage = ""
      }
    }



  }
}
</script>

<style lang="less" scoped>
.open {
  color: #246ead;
  cursor: pointer;
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
}
</style>